import { render, staticRenderFns } from "./dial.vue?vue&type=template&id=16c2af62&scoped=true"
import script from "./dial.vue?vue&type=script&lang=js"
export * from "./dial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2af62",
  null
  
)

export default component.exports